import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
// import SinglePage from "../SinglePage/SinglePage";
import { baseURL } from "../../../basics";
import ShowPriceInCardItem from "./ShowPriceInCardItem";
import LikeAndUnLikeButton from "../../Ui/LikeAndUnLikeButton";
import UnitTypeBox from "../../Ui/UnitTypeBox";
import GradeDescription from "../../Ui/GradeDescription";
import CheckStockAndChangeButton from "../../Ui/CheckStockAndChangeButton";
// import { useSelector } from "react-redux";

const ProductItemInMobile = (props: any) => {
  const {
    id,
    title,
    price,
    imageUrl,
    stock,
    discountedPrice,
    isSpecial,
    unit,
    unitType,
    grade,
  } = props.items;
  const [refresh, setRefresh] = useState(false);
  const [noStock, setNoStock] = useState(false);
  // const [showSinglePage, setShowSinglePage] = useState(false);
  const handleRefresh = () => {
    setRefresh(!refresh);
  };
  // //console.log("props:::::::::::", props.items);
  // const dispatch = useDispatch();
  // const addToCartHandler = () => {
  //   dispatch(
  //     cartActions.addItemToCart({
  //       // inja chon mikhastim be in surat benvisim ke id:id, title:title,... pas ba tavajoh be modern javascript shortcut be surate zir minenisim:
  //       id,
  //       imageUrl,
  //       title,
  //       price,
  //       grade,
  //       quantity: 1,
  //     })
  //   );
  // };
  // const Token = useSelector((state: any) => state.auth.token);
  // const addToFavoriteHandler = () => {
  //   dispatch(cartActions.addOrRemoveFavoriteItemInList(props.items));
  //   dispatch(dispatch(sendFavoriteCartData(id, Token)));
  //   //console.log("addToFavoriteHandler:::", id, Token);
  // };
  //  const CategoryId = useSelector((state:any)=> state.category.categoryId)
  // const amountOfItem: any = () => {
  // const eachItem: any = cartCtx.items.find(
  //   (item: any) => item.id === props.id
  // );
  // if (eachItem) {
  //   return eachItem.amount;
  // }
  // };
  // anItem();
  // //console.log("anItem", anItem());
  // //console.log('cartAmount',cartAmount);
  const showNoStockHandler = () => {
    setNoStock(true);
  };
  const hideNoStockHandler = () => {
    setNoStock(false);
  };
  const showProductPageHandler = () => {
    //console.log("showProductPageHandler", id);
    // maybe in this function we should use React Router
    // to send users to product's page
    // //// or we should handle one boolean parameter in redux to
    // handle showing SinglePage with click and render this function
    //  I think we should handle this change in App component
    // setShowSinglePage(true);
  };
  // //console.log('props.id',props);
  // const favoriteCartData = useSelector(
  //   (state: any) => state.cart.favoriteItems.items
  // );
  // const existInFavoriteItem = favoriteCartData.find(
  //   (item: any) => item.id === id
  // )
  //   ? true
  //   : false;
  const history = useHistory();
  const sendUserToProductItemPage = () => {
    history.push(`/products/productItem/${id}`);
  };
  const [truncatedText, settRuncatedText] = useState("");
  useEffect(() => {
    if (title) {
      const rangeStart = 0;
      const rangeEnd = 20;
      // //console.log('title',title);
      const lastWordBoundary = title.lastIndexOf(" ", rangeEnd);
      const truncatedText =
        lastWordBoundary >= rangeEnd
          ? `${title.substring(rangeStart, lastWordBoundary)} ...`
          : `${title.substring(rangeStart, rangeEnd)}`;
      settRuncatedText(truncatedText);
    }
  }, [title]);
  return (
    <div className="relative ">
      <form className="bg-white rounded-xl shadow-sm border border-slate-100 my-2 relative overflow-hidden w-full h-[110px] px-3">
        <LikeAndUnLikeButton item={props.items} />
        <CheckStockAndChangeButton
          parentStyles={"absolute left-2 bottom-2"}
          childStyles={"flex-row-reverse bg-emerald-500 hover:bg-emerald-600 shadow-sm"}
          items={props.items}
        />
        <div
          onClick={sendUserToProductItemPage}
          className="flex justify-start items-center h-full cursor-pointer pl-32"
        >
          <div className="flex justify-start items-center">
            <img
              src={`${baseURL}${imageUrl}`}
              alt={title}
              // onClick={showProductPageHandler}
              className="h-20 w-20 object-contain rounded-full m-3 bg-slate-50 ring-1 ring-black/5"
            />
          </div>
          {/* <p className="ml-4">{price}</p>
            <p className="ml-4">{stock}</p> */}
          <div className="text-base px-2 flex-1 min-w-0">
            <div
              onClick={showProductPageHandler}
              className="flex flex-col items-start w-full"
            >
              <p className="w-full py-1 text-gray-900 font-bold leading-7 truncate">
                {truncatedText}
              </p>

              <GradeDescription grade={grade} color={"black"} />
              <div className="py-1 flex justify-start items-center gap-2 flex-nowrap">
                <UnitTypeBox unit={unit} unitType={unitType} />
                <ShowPriceInCardItem
                  price={price}
                  discountedPrice={discountedPrice}
                />
              </div>
            </div>
          </div>
        </div>
      </form>

      {/* {showSinglePage && <SinglePage id={id} />} */}
    </div>
  );
};
export default ProductItemInMobile;
